import mitt from '../../lib/mitt';
const analyticsEmitter = mitt();
export { analyticsEmitter };
